import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=acbfd5c6&scoped=true&"
import script from "./Home.vue?vue&type=script&lang=js&"
export * from "./Home.vue?vue&type=script&lang=js&"
import style0 from "./Home.vue?vue&type=style&index=0&id=acbfd5c6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../东方蚂蚁/e-shop/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acbfd5c6",
  null
  
)

export default component.exports